<div class="login-container">
  <div class="login-image">
    <div class="welcome-text">
      <h1>Willkommen zurück!</h1>
      <p>Bitte ändern Sie Ihr Passwort!</p>
    </div>
  </div>
  <mat-card appearance="outlined" class="login-card">
    <mat-card-header>
      <div mat-card-avatar>
        <mat-icon>lock</mat-icon>
      </div>
      <mat-card-title>Passwort ändern!</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="changePasswordForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Altes Passwort</mat-label>
          <input matInput [type]="hideOldPassword() ? 'password' : 'text'" formControlName="oldPassword" placeholder="Altes Passwort">
          <mat-error *ngIf="changePasswordForm.get('oldPassword')?.hasError('required')">
            Altes Passwort ist erforderlich
          </mat-error>
          <button mat-icon-button
                  matSuffix
                  type="button"
                  (click)="toggleVisibility(hideOldPassword)"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideOldPassword()">
            <mat-icon>{{hideOldPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Neues Passwort</mat-label>
          <input matInput [type]="hideNewPassword() ? 'password' : 'text'" formControlName="newPassword" placeholder="Neues Passwort">
          <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('required')">
            Neues Passwort ist erforderlich
          </mat-error>
          <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('minlength')">
            Neues Passwort muss min. 8 Zeichen lang sein
          </mat-error>
          <button mat-icon-button
                  matSuffix
                  type="button"
                  (click)="toggleVisibility(hideNewPassword)"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideNewPassword()">
            <mat-icon>{{hideNewPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Neues Passwort bestätigen</mat-label>
          <input matInput [type]="hideConfirmPassword() ? 'password' : 'text'" formControlName="confirmPassword" placeholder="Neues Passwort bestätigen">
          <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('required')">
            Neues Passwort bestätigen ist erforderlich
          </mat-error>
          <mat-error *ngIf="changePasswordForm.get('confirmPassword')?.hasError('not_matching')">
            Passwörter stimmen nicht überein
          </mat-error>
          <button mat-icon-button
                  matSuffix
                  type="button"
                  (click)="toggleVisibility(hideConfirmPassword)"
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideConfirmPassword()">
            <mat-icon>{{hideConfirmPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <div class="actions">
          <button mat-raised-button color="primary" type="submit" [disabled]="!changePasswordForm.valid || isLoading">
            Ändern
          </button>
        </div>
      </form>

      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <p *ngIf="error" class="error-message">{{ error }}</p>
    </mat-card-content>
  </mat-card>
</div>
